import { useState } from "react";
import { Check, Copy, ArrowRight, PartyPopper } from "lucide-react";

const CATALOG_URL = "https://edunation.com.pl/szkolenia-i-kursy/";
const DISCOUNT_CODE = "edu25";

function CodeBox() {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(DISCOUNT_CODE);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2500);
    } catch {
      /* kod można zaznaczyć ręcznie */
    }
  };
  return (
    <div className="flex flex-wrap items-center gap-3">
      <span
        data-testid="thankyou-discount-code"
        className="rounded-xl border-2 border-dashed border-[#FFB3DA] bg-white px-6 py-3 font-mono text-2xl font-extrabold tracking-widest text-[#FF008B]"
      >
        {DISCOUNT_CODE}
      </span>
      <button
        type="button"
        data-testid="thankyou-copy-code-button"
        onClick={copy}
        className="inline-flex min-h-[44px] items-center gap-2 rounded-full bg-[#242344] px-5 py-2 text-sm font-bold text-white transition-colors duration-200 hover:bg-[#FF008B]"
      >
        {copied ? <Check size={16} aria-hidden="true" /> : <Copy size={16} aria-hidden="true" />}
        {copied ? "Kod skopiowany" : "Kopiuj kod"}
      </button>
      <span aria-live="polite" className="sr-only">
        {copied ? "Kod skopiowany" : ""}
      </span>
    </div>
  );
}

export default function ThankYou() {
  return (
    <div className="min-h-screen bg-[#FAF8FC]">
      <div className="airmail-edge" aria-hidden="true" />
      <header className="flex justify-center px-4 pt-10">
        <img
          src="/assets/edunation-logo.png"
          alt="eduNation"
          className="h-10 w-auto"
          data-testid="thankyou-logo"
        />
      </header>

      <main className="mx-auto max-w-5xl px-4 pb-20 pt-10 sm:px-6 sm:pt-14">
        <div className="text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-[#FDF4F8] px-4 py-2 text-sm font-bold text-[#FF008B]">
            <PartyPopper size={16} aria-hidden="true" />
            Zakup zakończony pomyślnie
          </span>
          <h1
            data-testid="thankyou-heading"
            className="mx-auto mt-5 max-w-3xl text-3xl font-extrabold tracking-tight text-[#242344] sm:text-4xl"
          >
            Dziękujemy za zaufanie i za zakup na naszej Platformie edunation!
          </h1>
        </div>

        <div className="mt-10 grid items-center gap-8 overflow-hidden rounded-3xl border border-[#EAE6F0] bg-white shadow-xl shadow-[#242344]/5 md:grid-cols-2">
          <div className="flex h-full flex-col items-center justify-end bg-white px-6 pt-6">
            <img
              src="/assets/trenerki.webp"
              alt="Anna Popławska i Luiza Wójtowicz-Waga — zespół EduNation"
              width="1010"
              height="1476"
              className="max-h-[26rem] w-auto max-w-full object-contain"
              data-testid="thankyou-photo"
            />
            <p className="pb-5 pt-3 text-sm font-semibold text-[#68677A]">Zespół EduNation</p>
          </div>
          <div className="p-7 sm:p-10">
            <p className="text-base leading-relaxed text-[#34343F] sm:text-lg">
              Dziękując Ci za to, że z nami jesteś i aby umilić kolejne zakupy, przygotowałyśmy
              dla Ciebie <strong className="text-[#242344]">kod zniżkowy na 25%!</strong>
            </p>
            <p className="mt-6 text-lg font-bold text-[#242344]">Twój kod na kolejne zakupy to:</p>
            <div className="mt-3">
              <CodeBox />
            </div>
            <p className="mt-4 text-sm text-[#68677A]">*kod zakupowy jest ważny przez 7 dni.</p>
            <a
              href={CATALOG_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="thankyou-catalog-button"
              className="mt-7 inline-flex min-h-[52px] items-center justify-center gap-2 rounded-full bg-[#FF008B] px-8 py-3 text-base font-bold text-white shadow-lg shadow-[#FF008B]/25 transition-all duration-200 hover:-translate-y-0.5 hover:bg-[#D90077]"
            >
              Przejdź do katalogu szkoleń
              <ArrowRight size={18} aria-hidden="true" />
            </a>
          </div>
        </div>
      </main>
    </div>
  );
}
